import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Search } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface StockRestockDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  selectedProductId: string;
  setSelectedProductId: (id: string) => void;
  restockQuantity: string;
  setRestockQuantity: (quantity: string) => void;
  productSearchQuery: string;
  setProductSearchQuery: (query: string) => void;
  handleRestockConfirm: () => void;
  filteredProducts: any[];
}

export const StockRestockDialog = ({
  isOpen,
  onOpenChange,
  selectedProductId,
  setSelectedProductId,
  restockQuantity,
  setRestockQuantity,
  productSearchQuery,
  setProductSearchQuery,
  handleRestockConfirm,
  filteredProducts,
}: StockRestockDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Réapprovisionnement de stock</DialogTitle>
          <DialogDescription>
            Sélectionnez un produit et spécifiez la quantité à ajouter
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="space-y-2">
            <Label>Rechercher un produit</Label>
            <div className="relative">
              <Input
                type="text"
                placeholder="Rechercher un produit..."
                value={productSearchQuery}
                onChange={(e) => setProductSearchQuery(e.target.value)}
                className="pl-8"
              />
              <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
            </div>
          </div>

          <div className="space-y-2">
            <Label>Sélectionner un produit</Label>
            <Select value={selectedProductId} onValueChange={setSelectedProductId}>
              <SelectTrigger>
                <SelectValue placeholder="Choisir un produit" />
              </SelectTrigger>
              <SelectContent>
                {filteredProducts?.map((item) => (
                  <SelectItem key={item.id} value={item.id}>
                    {item.data.name} - {item.quantity} {item.data.unit || 'unités'}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label>Quantité à ajouter</Label>
            <Input
              type="number"
              min="1"
              value={restockQuantity}
              onChange={(e) => setRestockQuantity(e.target.value)}
              placeholder="Entrez la quantité"
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Annuler
          </Button>
          <Button onClick={handleRestockConfirm}>
            Confirmer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};